<div class="no-items-message">
  <mat-icon [svgIcon]="svgIconName.INFO_OUTLINE" class="no-items-message__icon"></mat-icon>
  <div>{{message}}</div>
</div>
